module.exports = __webpack_public_path__ + "img/top03.6992840f.png";